export default __webpack_public_path__ + "static/char-v-18-0fd14632fd23f067b907cd6bd5b60d11.webp";